import { c as _c } from "react/compiler-runtime";
import { Button, HStack, Input, InputGroup, SimpleGrid, VStack, Field } from '@chakra-ui/react';
import { CurrencyInput } from '@src/components/sco/CurrencyInput';
import { HelpModal } from '@src/components/sco/Requests/RequestBuilder/FormSections/HelpModal';
import { RequestBuilderFormProps } from '@src/components/sco/Requests/RequestBuilder/FormSections/index';
import { RichMarkdownInput } from '@src/components/sco/RichMarkdownInput';
import { ScoTagComboboxInput } from '@src/components/sco/ScoTagComboboxInput';
import { SelectableButtons } from '@src/components/sco/SelectableButtons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { groupRequestTypesSelectableButtonOptions } from '@src/constants/group-request-types';
import { UpsertGroupRequestInput } from '@src/graphql-types';
import React, { useEffect, useState } from 'react';
import { LuPencilLine } from 'react-icons/lu';
export const RequestTypeSection: React.FC<RequestBuilderFormProps> = props => {
  const $ = _c(58);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const groupRequest = props.groupRequest;
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [groupRequestTypeKey, setGroupRequestTypeKey] = useState(groupRequest.groupRequestTypeKey || "");
  const [naturalLanguagePrompt, setNaturalLanguagePrompt] = useState(groupRequest.naturalLanguagePrompt);
  const [fundingGoalInDollars, setFundingGoalInDollars] = useState(groupRequest.investorSearch?.fundingGoalInDollars || null);
  let t0;
  if ($[0] !== groupRequest.tagTitles) {
    t0 = groupRequest?.tagTitles || [];
    $[0] = groupRequest.tagTitles;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [selectedTagTitles, setSelectedTagTitles] = useState(t0);
  let t1;
  if ($[2] !== fundingGoalInDollars || $[3] !== groupRequestTypeKey || $[4] !== naturalLanguagePrompt || $[5] !== props || $[6] !== selectedTagTitles) {
    t1 = async t2 => {
      const next = t2 === undefined ? _temp : t2;
      if (!props.groupRequest.groupRequestId) {
        alert("Cannot save, record not loaded yet.");
        return;
      }
      await props.upsertGroupRequest({
        variables: {
          input: {
            groupRequestId: props.groupRequest.groupRequestId,
            groupRequestTypeKey,
            naturalLanguagePrompt,
            upsertInvestorSearchInput: {
              fundingGoalInDollars,
              requiredInvestorTagTitles: selectedTagTitles
            },
            upsertUserSearchInput: {
              requiredSkillTitles: selectedTagTitles
            },
            tagTitles: selectedTagTitles.filter(Boolean)
          } as UpsertGroupRequestInput
        }
      });
      if (next) {
        next();
      }
    };
    $[2] = fundingGoalInDollars;
    $[3] = groupRequestTypeKey;
    $[4] = naturalLanguagePrompt;
    $[5] = props;
    $[6] = selectedTagTitles;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const performSave = t1;
  let t2;
  let t3;
  if ($[8] !== groupRequest.groupRequestTypeKey) {
    t2 = () => {
      setGroupRequestTypeKey(groupRequest.groupRequestTypeKey);
    };
    t3 = [groupRequest.groupRequestTypeKey];
    $[8] = groupRequest.groupRequestTypeKey;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  let t4;
  if ($[11] !== performSave) {
    t4 = () => {
      performSave();
    };
    $[11] = performSave;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== groupRequestTypeKey) {
    t5 = [groupRequestTypeKey];
    $[13] = groupRequestTypeKey;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  let t6;
  if ($[15] !== getBreakpointValue) {
    t6 = getBreakpointValue([1, 3]);
    $[15] = getBreakpointValue;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== groupRequest.groupRequestTypeKey) {
    t7 = [groupRequest.groupRequestTypeKey].filter(Boolean);
    $[17] = groupRequest.groupRequestTypeKey;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  let t9;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = groupRequestTypesSelectableButtonOptions.map(_temp2);
    t9 = selections => {
      setGroupRequestTypeKey(selections[0]?.key);
    };
    $[19] = t8;
    $[20] = t9;
  } else {
    t8 = $[19];
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7) {
    t10 = <SelectableButtons defaultValue={t7} maxSelections={1} options={t8} onChange={t9} />;
    $[21] = t7;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t6) {
    t11 = <SimpleGrid columns={t6} gap={3} width="full">{t10}</SimpleGrid>;
    $[23] = t10;
    $[24] = t6;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = groupRequestTypeKey === "goal" ? "solid" : "outline";
  let t13;
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = () => setGroupRequestTypeKey("goal");
    t14 = <LuPencilLine />;
    $[26] = t13;
    $[27] = t14;
  } else {
    t13 = $[26];
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t12) {
    t15 = <Button marginTop={4} variant={t12} width="full" onClick={t13}>{t14}Or, Define Your Own Goal</Button>;
    $[28] = t12;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t11 || $[31] !== t15) {
    t16 = <Field.Root>{t11}{t15}</Field.Root>;
    $[30] = t11;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div />;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== fundingGoalInDollars || $[35] !== groupRequestTypeKey || $[36] !== performSave) {
    t18 = groupRequestTypeKey === "funding" && <Field.Root><Field.Label>Funding Goal Amount</Field.Label><InputGroup startAddon="$"><Input asChild={true} value={fundingGoalInDollars}><CurrencyInput onBlur={ev => performSave()} onNumericValueChange={value => setFundingGoalInDollars(value)} /></Input></InputGroup></Field.Root>;
    $[34] = fundingGoalInDollars;
    $[35] = groupRequestTypeKey;
    $[36] = performSave;
    $[37] = t18;
  } else {
    t18 = $[37];
  }
  let t19;
  if ($[38] !== groupRequestTypeKey || $[39] !== naturalLanguagePrompt) {
    t19 = groupRequestTypeKey === "goal" && <Field.Root><Field.Label>Tell us a little more...</Field.Label><RichMarkdownInput initialMarkdownValue={naturalLanguagePrompt} onChange={values => setNaturalLanguagePrompt(values.markdown)} /></Field.Root>;
    $[38] = groupRequestTypeKey;
    $[39] = naturalLanguagePrompt;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== groupRequest.tags || $[42] !== groupRequestTypeKey) {
    t20 = !["funding"].includes(groupRequestTypeKey) && <><Field.Root><Field.Label>What skills are you looking for?</Field.Label><ScoTagComboboxInput defaultSelectedTagTitles={groupRequest.tags?.map(_temp3) || []} tagTypeKeys={["skill"]} onSelectedTagsChange={tags => setSelectedTagTitles(tags.map(_temp4))} /></Field.Root></>;
    $[41] = groupRequest.tags;
    $[42] = groupRequestTypeKey;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== performSave || $[45] !== props) {
    t21 = <HStack justify="flex-end" paddingY={2} width="full"><Button size="xs" variant="cta" onClick={async e => {
        await performSave(() => props.onNextSection ? props.onNextSection() : null);
      }}>{"Save & Continue"}</Button></HStack>;
    $[44] = performSave;
    $[45] = props;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t16 || $[48] !== t18 || $[49] !== t19 || $[50] !== t20 || $[51] !== t21) {
    t22 = <VStack align="stretch" gap={4} padding={4}>{t16}{t17}{t18}{t19}{t20}{t21}</VStack>;
    $[47] = t16;
    $[48] = t18;
    $[49] = t19;
    $[50] = t20;
    $[51] = t21;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== showHelpModal) {
    t23 = <HelpModal setShowHelpModal={setShowHelpModal} showHelpModal={showHelpModal} />;
    $[53] = showHelpModal;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== t22 || $[56] !== t23) {
    t24 = <>{t22}{t23}</>;
    $[55] = t22;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  return t24;
};
function _temp() {}
function _temp2(x) {
  return {
    ...x,
    selectableButtonProps: {
      ...x.selectableButtonProps,
      buttonProps: {
        ...x.selectableButtonProps.buttonProps,
        size: "xs"
      }
    }
  };
}
function _temp3(t) {
  return t.title;
}
function _temp4(t_0) {
  return t_0.title;
}